import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store';
import NavBar from '@/components/nav-drawer.vue';
import Home from '../views/Home.vue';
import AdminNavBar from '../views/AdminPages/AdminNavBar.vue';
import OrgComp from '../components/OrgComponent.vue';

const ifAuthenticated = (to: any, from: any, next: any) => {
  if (store.getters.authenticated) {
    // const check = PageAuthorizer.isAuthorized(to.path);
    next();
    // if (PageAuthorizer.isAuthorized(to.path)) {
    //   next();
    // } else {
    //   next('/unAuthorised');
    // }
  } else {
    next(`/login?redirect=${to.path}`);
  }
};

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    components: {
      default: Home,
      Navigator: NavBar,
    },
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/admin',
    name: 'Admin',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () => import(/* webpackChunkName: "admin" */ '@/views/Admin.vue'),
    components: {
      default: () => import(/* webpackChunkName: "admin" */ '@/views/Admin.vue'),
      Navigator: AdminNavBar,
    },
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
    components: {
      default: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
      Navigator: AdminNavBar,
    },
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/login',
    name: 'Login',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue'),
  },
  {
    path: '/register',
    name: 'Register',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () => import(/* webpackChunkName: "Register" */ '../views/Register.vue'),
    components: {
      default: () => import(/* webpackChunkName: "Register" */ '../views/Register.vue'),
      Navigator: NavBar,
    },
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/favourite',
    name: 'Favourite',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    components: {
      default: () => import(/* webpackChunkName: "Fevorate" */ '../views/Favourite.vue'),
      Navigator: NavBar,
    },
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/organization/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    components: {
      default: OrgComp,
      Navigator: NavBar,
      MainComp: () => import(/* webpackChunkName: "orgAbout" */ '../components/Organization/About.vue'),
    },
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/organization/posts',
    name: 'Post',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    components: {
      default: OrgComp,
      Navigator: NavBar,
      MainComp: () => import(/* webpackChunkName: "postview" */ '../components/Organization/PostView.vue'),
    },
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/organization/privateposts',
    name: 'PrivatePosts',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    components: {
      default: OrgComp,
      Navigator: NavBar,
      MainComp: () => import(/* webpackChunkName: "postview" */ '../components/Organization/PostViewPrivate.vue'),
    },
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/organization/followers',
    name: 'Followers',
    components: {
      default: OrgComp,
      Navigator: NavBar,
      MainComp: () => import(/* webpackChunkName: "followers" */ '../components/Organization/Followers.vue'),
    },
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/organization/members',
    name: 'Members',
    components: {
      default: OrgComp,
      Navigator: NavBar,
      MainComp: () => import(/* webpackChunkName: "members" */ '../components/Organization/Members.vue'),
    },
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/organization/moderator',
    name: 'Moderator',
    components: {
      default: OrgComp,
      Navigator: NavBar,
      MainComp: () => import(/* webpackChunkName: "moderators" */ '../components/Organization/MemberModeration.vue'),
    },
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/organization/group',
    name: 'Group',
    components: {
      default: OrgComp,
      Navigator: NavBar,
      MainComp: () => import(/* webpackChunkName: "group" */ '../components/Organization/Group.vue'),
    },
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/userProfile/:id',
    name: 'UserProfile',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () => import(/* webpackChunkName: "UserProfile" */ '@/views/UserProfile.vue'),
    components: {
      default: () => import(/* webpackChunkName: "UserProfile" */ '@/views/UserProfile.vue'),
      Navigator: NavBar,
    },
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/messenger',
    name: 'Messenger',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () => import(/* webpackChunkName: "messenger" */ '@/views/Messenger.vue'),
    components: {
      default: () => import(/* webpackChunkName: "messenger" */ '@/views/Messenger.vue'),
      Navigator: NavBar,
    },
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/roles',
    name: 'Roles',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () => import(/* webpackChunkName: "roles" */ '@/views/Roles.vue'),
    components: {
      default: () => import(/* webpackChunkName: "roles" */ '@/views/Roles.vue'),
      Navigator: AdminNavBar,
    },
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/report',
    name: 'Report',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    components: {
      default: () => import(/* webpackChunkName: "report" */ '@/views/AdminPages/Report.vue'),
      Navigator: AdminNavBar,
    },
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/people',
    name: 'People',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () => import(/* webpackChunkName: "People" */ '@/views/People.vue'),
    components: {
      default: () => import(/* webpackChunkName: "People" */ '@/views/People.vue'),
      Navigator: NavBar,
    },
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/post/:id',
    name: 'PostView',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () => import(/* webpackChunkName: "messenger" */ '@/views/PostDetailView.vue'),
    components: {
      default: () => import(/* webpackChunkName: "messenger" */ '@/views/PostDetail.vue'),
      Navigator: NavBar,
    },
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/reciveds',
    name: 'Reciveds',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () => import(/* webpackChunkName: "reciveds" */ '@/views/Reciveds.vue'),
    components: {
      default: () => import(/* webpackChunkName: "reciveds" */ '@/views/Reciveds.vue'),
      Navigator: NavBar,
    },
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/friends',
    name: 'Friends',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "friends" */ '@/views/Friends.vue'),
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/sentReqs',
    name: 'SentReqs',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () => import(/* webpackChunkName: "sentReqs" */ '@/views/SentReqs.vue'),
    components: {
      default: () => import(/* webpackChunkName: "sentReqs" */ '@/views/SentReqs.vue'),
      Navigator: NavBar,
    },
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/organization',
    name: 'Organization',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () => import(/* webpackChunkName: "Organization" */ '../views/Organization.vue'),
    components: {
      default: () => import(/* webpackChunkName: "Organization" */ '../views/Organization.vue'),
      Navigator: AdminNavBar,
    },
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/notification',
    name: 'Notification',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () => import(/* webpackChunkName: "Organization" */ '../views/Organization.vue'),
    components: {
      default: () => import(/* webpackChunkName: "Organization" */ '@/components/Notification.vue'),
      Navigator: NavBar,
    },
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/organization/:id',
    name: 'OrgComponent',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component:()=>import(/* webpackChunkName: "OrgComponent" */ '@/components/OrgComponent.vue'),
    components: {
      default: () => import(/* webpackChunkName: "OrgComponent" */ '@/components/OrgComponent.vue'),
      Navigator: NavBar,
    },
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/campaignAdd',
    name: 'CampaignAdd',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () => import(/* webpackChunkName: "CampaignAdd" */ '../views/CampaignAdd.vue'),
    components: {
      default: () => import(/* webpackChunkName: "CampaignAdd" */ '../views/CampaignAdd.vue'),
      Navigator: AdminNavBar,
    },
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/unAuthorised',
    name: 'UnAuthorised',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "unAuthorised" */ '../views/UnAuthorised.vue'),
    components: {
      default: () => import(/* webpackChunkName: "unAuthorised" */ '../views/UnAuthorised.vue'),
      Navigator: NavBar,
    },
    beforeEnter: ifAuthenticated,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
